import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-3 pt-1" }
const _hoisted_2 = {
  for: "is-carrier-active",
  class: "d-flex align-items-center cursor-pointer"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "d-block ms-2" }, "Active", -1)
const _hoisted_4 = { class: "mt-4 pt-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "card-title subtitle" }, "Network Features", -1)
const _hoisted_6 = { class: "carrier-network-features d-flex flex-wrap mt-3" }
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "font-15 pe-3" }
const _hoisted_9 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarUpload = _resolveComponent("AvatarUpload")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppInputsValidationProvider = _resolveComponent("AppInputsValidationProvider")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_AppSwitch = _resolveComponent("AppSwitch")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    title: _ctx.modalTitle,
    opened: _ctx.opened,
    onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('hide')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_AvatarUpload, {
        title: "Please, upload carrier icon.",
        size: "60x60",
        placeholder: _ctx.image,
        onFileChanged: _ctx.fileUpload
      }, null, 8, ["placeholder", "onFileChanged"]),
      _createElementVNode("form", {
        class: "mt-4 pt-2",
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createVNode(_component_AppInputsValidationProvider, { onChangeErrorState: _ctx.changeErrorState }, {
          default: _withCtx(() => [
            _createVNode(_component_AppInput, {
              id: "carrier-title",
              modelValue: _ctx.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
              "input-type": "material",
              required: true,
              "validation-type": "notEmptyString",
              label: "Title"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["onChangeErrorState"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rates, (rate) => {
          return (_openBlock(), _createElementBlock("div", {
            key: rate.id,
            class: "mt-3"
          }, [
            _createVNode(_component_AppInput, {
              id: rate.id,
              modelValue: rate.rate,
              "onUpdate:modelValue": ($event: any) => ((rate.rate) = $event),
              "input-type": "material",
              required: true,
              "validation-type": "notEmptyString",
              type: "number",
              label: rate.plan.name
            }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "label"])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("label", _hoisted_2, [
            _createVNode(_component_AppCheckbox, {
              id: "is-carrier-active",
              modelValue: _ctx.active,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.active) = $event)),
              checked: _ctx.active
            }, null, 8, ["modelValue", "checked"]),
            _hoisted_3
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("ul", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.netGens, ({ networkGeneration, active }) => {
              return (_openBlock(), _createElementBlock("li", {
                key: networkGeneration.title,
                class: "carrier-network-features--item me-5 mt-3"
              }, [
                _createElementVNode("label", {
                  for: networkGeneration.title,
                  class: "d-flex align-items-center"
                }, [
                  _createElementVNode("strong", _hoisted_8, _toDisplayString(networkGeneration.title), 1),
                  _createVNode(_component_AppSwitch, {
                    id: networkGeneration.title,
                    "model-value": active,
                    onChange: 
                  (checked) => _ctx.changeNetGens(networkGeneration.id, checked)
                
                  }, null, 8, ["id", "model-value", "onChange"])
                ], 8, _hoisted_7)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_AppButton, {
            disabled: !_ctx.valid,
            type: "secondary",
            size: "xl",
            loading: _ctx.loading,
            onClick: _ctx.submitHandler
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.buttonLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading", "onClick"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["title", "opened"]))
}